import styled from "styled-components";
import { EventAttendeeType } from "../../../../../../api/event-schedule";

export const EventScheduleListWrapper = styled.div`
  padding-bottom: 60px;

  > .list-wrapper {
    display: flex;
    flex-direction: column;

    padding: 20px 0 0 0;
  }
  .no-data {
    font-weight: 500;
    font-size: 16px;
    text-align: center;
  }

  > .calender {
    margin: 20px 16px 0;
    display: flex;
    justify-content: flex-end;
  }
`;

export const EventScheduleItemBar = styled.div`
  border-bottom: 1px solid #dedede;
  width: 100%;
  height: 1px;
  margin: 8px 0;
`;

export const EventScheduleListDate = styled.div`
  margin: 0 16px 12px;
  display: flex;
  justify-content: space-between;

  > .date {
    background: #7f25fb;
    font-weight: 600;
    font-size: 14px;
    height: 29px;
    border-radius: 14px;
    text-align: center;
    line-height: 29px;
    color: #fff;
    padding: 0 16px;
  }
`;

export const EventScheduleListItem = styled.div<{ type: EventAttendeeType }>`
  margin-bottom: ${(p) =>
    p.type === EventAttendeeType.AMBASSADOR ? "12px" : "0"};
  background: ${(p) =>
    p.type === EventAttendeeType.AMBASSADOR ? "#001E94" : "#fff"};
  display: flex;
  color: ${(p) => (p.type === EventAttendeeType.AMBASSADOR ? "#fff" : "#000")};
  height: ${(p) =>
    p.type === EventAttendeeType.AMBASSADOR ? "100px" : "63px"};
  align-items: center;
  > .info {
    padding-left: ${(p) =>
      p.type === EventAttendeeType.AMBASSADOR ? "0px" : "16px"};
    display: flex;
    flex-direction: column;
    gap: 2px;

    > .name {
      text-align: center;
      margin-bottom: ${(p) =>
        p.type === EventAttendeeType.AMBASSADOR ? "4px" : "2px"};
      color: ${(p) =>
        p.type === EventAttendeeType.AMBASSADOR ? "#121212" : "#fff"};
      font-family: Pretendard;
      font-size: 10px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      padding: ${(p) =>
        p.type === EventAttendeeType.AMBASSADOR ? "4px 12px" : "2px 8px"};
      border-radius: 30px;
      background: ${(p) =>
        p.type === EventAttendeeType.AMBASSADOR ? "#fff" : "#444"};
      width: fit-content;
    }
    > .pub {
      font-weight: 700;
      font-size: ${(p) =>
        p.type === EventAttendeeType.AMBASSADOR ? "18px" : "16px"};
    }
    > .title {
      font-weight: 500;
      font-size: ${(p) =>
        p.type === EventAttendeeType.AMBASSADOR ? "14px" : "12px"};
    }
  }

  > .AMBASSADOR {
    position: relative;

    > .img {
      width: 91px;
      height: 100px;
      > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  > .YOUTUBER {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;
    padding-left: 16px;

    > .img {
      width: 55px;
      height: 55px;

      > img {
        border-radius: 50%;
        width: 100%;
        height: 100%;
      }
    }

    > .name {
      font-weight: 700;
      font-size: 12px;
      color: #121212;
    }
  }
`;
